import { normalizeLocale } from './settings'

export function localeRootPath(locale: string): string {
  return `/${normalizeLocale(locale)}`
}

export function pathWithLocale(locale: string, pathname: string): string {
  const l = normalizeLocale(locale)
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`
  return `/${l}${path}`
}
